import { Provider } from "./provider/Provider";

const UrunlerService = {
  kategoriListesi: () => {
    return Provider({
      methodName: "Module/Urunler/KategoriListesi",
    });
  },
  kategoriEkle: ({ kategoriAdi, kategoriAciklamasi, kategoriEbeveyni }) => {
    return Provider({
      kategoriAdi,
      kategoriAciklamasi,
      kategoriEbeveyni,
      methodName: "Module/Urunler/KategoriEkle",
    });
  },
  kategoriGuncelle: ({
    kategoriCode,
    kategoriAdi,
    kategoriAciklamasi,
    kategoriEbeveyni,
  }) => {
    return Provider({
      kategoriCode,
      kategoriAdi,
      kategoriAciklamasi,
      kategoriEbeveyni,
      methodName: "Module/Urunler/KategoriGuncelle",
    });
  },
  kategoriKaldir: ({ kategoriCode }) => {
    return Provider({
      kategoriCode,
      methodName: "Module/Urunler/KategoriKaldir",
    });
  },
  kategoriDetay: ({ kategoriCode }) => {
    return Provider({
      kategoriCode,
      methodName: "Module/Urunler/KategoriDetay",
    });
  },
  urunEkle: ({
    urunAdi,
    urunKodu,
    urunLink,
    urunKategorisi,
    urunTuru,
    urunVaryasyonlari,
    urunOzellikleri,
    urunAciklamasi,
  }) => {
    return Provider({
      urunAdi,
      urunKodu,
      urunLink,
      urunKategorisi,
      urunTuru,
      urunVaryasyonlari,
      urunOzellikleri,
      urunAciklamasi,
      methodName: "Module/Urunler/UrunEkle",
    });
  },
  urunDuzenle: ({
    urunCode,
    urunAdi,
    urunKodu,
    urunLink,
    urunKategorisi,
    urunTuru,
    urunVaryasyonlari,
    urunOzellikleri,
    urunAciklamasi,
  }) => {
    return Provider({
      urunCode,
      urunAdi,
      urunKodu,
      urunLink,
      urunKategorisi,
      urunTuru,
      urunVaryasyonlari,
      urunOzellikleri,
      urunAciklamasi,
      methodName: "Module/Urunler/UrunDuzenle",
    });
  },
  kategoriUrunList: () => {
    return Provider({
      methodName: "Module/Option/Option",
    });
  },
  urunAlanlari: () => {
    return Provider({
      methodName: "Module/Urunler/UrunAlanlari",
    });
  },
  urunBoyutlari: () => {
    return Provider({
      methodName: "Module/Urunler/UrunBoyutlari",
    });
  },
  urunListesi: ({ baslangic, limit, kategoriListesi, durum }) => {
    return Provider({
      baslangic,
      limit,
      kategoriListesi,
      durum,
      methodName: "Module/Urunler/PanelUrunListesi",
    });
  },
  urunDetay: (urunCode) => {
    return Provider({
      urunCode,
      methodName: "Module/Urunler/UrunDetay",
    });
  },
  urunAra: ({ ara, type, kategori, baslangic, limit }) => {
    return Provider({
      ara,
      type,
      kategori,
      baslangic,
      limit,
      methodName: "Module/Urunler/PanelUrunAra",
    });
  },
  urunSayisi: ({ kategoriListesi, durum }) => {
    return Provider({
      kategoriListesi,
      durum,
      methodName: "Module/Urunler/UrunSayisi",
    });
  },
  urunAraSayisi: ({ ara, type, kategori }) => {
    return Provider({
      ara,
      type,
      kategori,
      methodName: "Module/Urunler/UrunAraSayisi",
    });
  },
  urunleriYayinaAl: (urunCodeList) => {
    return Provider({
      urunCodeList,
      methodName: "Module/Urunler/UrunleriYayinaAl",
    });
  },
  urunleriYayindanKaldir: (urunCodeList) => {
    return Provider({
      urunCodeList,
      methodName: "Module/Urunler/UrunleriYayindanKaldir",
    });
  },
  urunleriSistemdenKaldir: (urunCodeList) => {
    return Provider({
      urunCodeList,
      methodName: "Module/Urunler/UrunleriSistemdenKaldir",
    });
  },
  yayinaAl: (urunCode) => {
    return Provider({
      urunCode,
      methodName: "Module/Urunler/YayinaAl",
    });
  },
  yayindanKaldir: (urunCode) => {
    return Provider({
      urunCode,
      methodName: "Module/Urunler/YayindanKaldir",
    });
  },
  sistemdenKaldir: (urunCode) => {
    return Provider({
      urunCode,
      methodName: "Module/Urunler/SistemdenKaldir",
    });
  },
  urunListeleri: (urunCode) => {
    return Provider({
      urunCode,
      methodName: "Module/Urunler/Listeler/UrunListeleri",
    });
  },
  urunListeDetay: (listeID) => {
    return Provider({
      listeID,
      methodName: "Module/Urunler/Listeler/UrunListeDetay",
    });
  },
  urunListeEkle: ({ listeAdi, listeAciklamasi, listeUrunleri }) => {
    return Provider({
      listeAdi,
      listeAciklamasi,
      listeUrunleri,
      methodName: "Module/Urunler/Listeler/UrunListeEkle",
    });
  },
  urunListeGuncelle: ({
    listeID,
    listeAdi,
    listeAciklamasi,
    listeUrunleri,
  }) => {
    return Provider({
      listeID,
      listeAdi,
      listeAciklamasi,
      listeUrunleri,
      methodName: "Module/Urunler/Listeler/UrunListeGuncelle",
    });
  },
  setUrunListeDurum: ({ listeID, durum }) => {
    return Provider({
      listeID,
      durum,
      methodName: "Module/Urunler/Listeler/SetUrunListeDurum",
    });
  },
  urunListeKaldir: (listeID) => {
    return Provider({
      listeID,
      methodName: "Module/Urunler/Listeler/UrunListeKaldir",
    });
  },
  setListeSiralama: (listeSiralamasi) => {
    return Provider({
      listeSiralamasi,
      methodName: "Module/Urunler/Listeler/setListeSiralama",
    });
  },
  nitelikListesi: () => {
    return Provider({
      methodName: "Module/Urunler/Nitelikler/NitelikListesi",
    });
  },
  nitelikTanimla: ({ nitelikAdi, nitelikler }) => {
    return Provider({
      nitelikAdi,
      nitelikler,
      methodName: "Module/Urunler/Nitelikler/NitelikTanimla",
    });
  },
  nitelikGuncelle: ({ nitelikCode, nitelikAdi, nitelikler }) => {
    return Provider({
      nitelikCode,
      nitelikAdi,
      nitelikler,
      methodName: "Module/Urunler/Nitelikler/NitelikGuncelle",
    });
  },
  nitelikKaldir: (nitelikCode) => {
    return Provider({
      nitelikCode,
      methodName: "Module/Urunler/Nitelikler/NitelikKaldir",
    });
  },
  nitelikDegeriGuncelle: ({ nitelikDegerCode, nitelikAdi }) => {
    return Provider({
      nitelikDegerCode,
      nitelikAdi,
      methodName: "Module/Urunler/Nitelikler/NitelikDegeriGuncelle",
    });
  },
  nitelikDegeriEkle: ({ nitelikCode, nitelikDegeri }) => {
    return Provider({
      nitelikCode,
      nitelikDegeri,
      methodName: "Module/Urunler/Nitelikler/NitelikDegeriEkle",
    });
  },
  nitelikDegeriKaldir: ({ nitelikCode, nitelikDegerCode }) => {
    return Provider({
      nitelikCode,
      nitelikDegerCode,
      methodName: "Module/Urunler/Nitelikler/NitelikDegeriKaldir",
    });
  },
  urunTuruListesi: () => {
    return Provider({
      methodName: "Module/Urunler/Turler/UrunTuruListesi",
    });
  },
  urunTuruDetay: (urunTuruCode) => {
    return Provider({
      urunTuruCode,
      methodName: "Module/Urunler/Turler/UrunTuruDetay",
    });
  },
  urunTuruEkle: ({ urunTuruAdi, urunTuruNitelikleri, urunTuruAciklamasi }) => {
    return Provider({
      urunTuruAdi,
      urunTuruNitelikleri,
      urunTuruAciklamasi,
      methodName: "Module/Urunler/Turler/UrunTuruEkle",
    });
  },
  urunTuruDuzenle: ({
    urunTuruCode,
    urunTuruAdi,
    urunTuruNitelikleri,
    urunTuruAciklamasi,
  }) => {
    return Provider({
      urunTuruCode,
      urunTuruAdi,
      urunTuruNitelikleri,
      urunTuruAciklamasi,
      methodName: "Module/Urunler/Turler/UrunTuruDuzenle",
    });
  },
  urunTuruKaldir: (urunTuruCode) => {
    return Provider({
      urunTuruCode,
      methodName: "Module/Urunler/Turler/UrunTuruKaldir",
    });
  },
  ozellikListesi: () => {
    return Provider({
      methodName: "Module/Urunler/Ozellikler/OzellikListesi",
    });
  },
  ozellikDetay: (ozellikCode) => {
    return Provider({
      ozellikCode,
      methodName: "Module/Urunler/Ozellikler/OzellikDetay",
    });
  },
  ozellikEkle: ({ ozellikAdi, ozellikAciklamasi }) => {
    return Provider({
      ozellikAdi,
      ozellikAciklamasi,
      methodName: "Module/Urunler/Ozellikler/OzellikEkle",
    });
  },
  ozellikDuzenle: ({ ozellikCode, ozellikAdi, ozellikAciklamasi }) => {
    return Provider({
      ozellikCode,
      ozellikAdi,
      ozellikAciklamasi,
      methodName: "Module/Urunler/Ozellikler/OzellikDuzenle",
    });
  },
  ozellikKaldir: (ozellikCode) => {
    return Provider({
      ozellikCode,
      methodName: "Module/Urunler/Ozellikler/OzellikKaldir",
    });
  },
  ozellikAra: ({ ara, start, limit, order }) => {
    return Provider({
      ara,
      start,
      limit,
      order,
      methodName: "Module/Urunler/Ozellikler/OzellikAra",
    });
  },
  currencyOptions:() => {
    return Provider({
      methodName: "Module/Urunler/currencyOptions",
    });
  }
};

export default UrunlerService;
